import { z } from 'zod';
export const stageStatusEnum = z.enum(['NOT_STARTED', 'IN_PROGRESS', 'COMPLETED', 'BLOCKED']);
export const progressTypeEnum = z.enum(['PERCENT', 'ITEMS', 'CUSTOM']);
export const stageItemStatusEnum = z.enum(['TODO', 'IN_PROGRESS', 'DONE', 'BLOCKED']);
export const createStageSchema = z.object({
    title: z.string().min(1).max(255),
    order: z.number().int().min(0),
    status: stageStatusEnum.default('NOT_STARTED'),
    progressType: progressTypeEnum.default('PERCENT'),
    progressValue: z.number().int().min(0).max(100).default(0),
    responsibleContractorId: z.string().optional(),
});
export const updateStageSchema = z.object({
    title: z.string().min(1).max(255).optional(),
    order: z.number().int().min(0).optional(),
    status: stageStatusEnum.optional(),
    progressType: progressTypeEnum.optional(),
    progressValue: z.number().int().min(0).max(100).optional(),
    responsibleContractorId: z.string().nullable().optional(),
});
export const stageItemSchema = z.object({
    id: z.string(),
    stageId: z.string(),
    title: z.string(),
    done: z.boolean(),
    status: stageItemStatusEnum,
    kanbanOrder: z.number().int(),
});
export const createStageItemSchema = z.object({
    title: z.string().min(1).max(255),
    done: z.boolean().default(false),
});
export const updateStageItemSchema = z.object({
    title: z.string().min(1).max(255).optional(),
    done: z.boolean().optional(),
    status: stageItemStatusEnum.optional(),
    kanbanOrder: z.number().int().min(0).optional(),
});
export const stageSchema = z.object({
    id: z.string(),
    projectId: z.string(),
    title: z.string(),
    order: z.number(),
    status: stageStatusEnum,
    progressType: progressTypeEnum,
    progressValue: z.number(),
    responsibleContractorId: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
    // Полный список items не приходит в списке этапов — грузится отдельной ручкой (GET /stages/:id/items)
    items: z.array(stageItemSchema).optional(),
    // Счетчики для отображения прогресса в списке этапов без загрузки самих items
    itemsCount: z.number().optional(),
    doneItemsCount: z.number().optional(),
    responsibleContractor: z.object({
        id: z.string(),
        name: z.string(),
    }).nullable().optional(),
});
// Шаблоны этапов ремонта (legacy enum для обратной совместимости)
export const stageTemplateEnum = z.enum([
    'APARTMENT_RENOVATION',
    'APARTMENT_RENOVATION_WITH_DESIGN',
    'HOUSE_CONSTRUCTION',
    'MINIMAL',
]);
export const applyTemplateSchema = z.object({
    templateId: z.string(),
    // Опциональный массив индексов этапов для выборочного применения
    // Если не указан - применяются все этапы
    selectedStageIndexes: z.array(z.number().int().min(0)).optional(),
});
// === Admin Stage Template Types ===
export const stageTemplateItemAdminSchema = z.object({
    id: z.string().optional(),
    title: z.string().min(1).max(255),
    order: z.number().int().min(0),
});
export const stageTemplateStageAdminSchema = z.object({
    id: z.string().optional(),
    title: z.string().min(1).max(255),
    order: z.number().int().min(0),
    items: z.array(stageTemplateItemAdminSchema),
});
export const stageTemplateAdminSchema = z.object({
    id: z.string(),
    slug: z.string(),
    label: z.string(),
    description: z.string().nullable(),
    order: z.number(),
    isActive: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
    stages: z.array(stageTemplateStageAdminSchema.extend({
        id: z.string(),
        items: z.array(stageTemplateItemAdminSchema.extend({
            id: z.string(),
        })),
    })),
});
export const createStageTemplateSchema = z.object({
    slug: z.string().min(1).max(100).regex(/^[A-Z_]+$/, 'Slug must be uppercase with underscores'),
    label: z.string().min(1).max(255),
    description: z.string().max(1000).optional(),
    order: z.number().int().min(0).optional(),
    isActive: z.boolean().optional(),
    stages: z.array(z.object({
        title: z.string().min(1).max(255),
        order: z.number().int().min(0),
        items: z.array(z.object({
            title: z.string().min(1).max(255),
            order: z.number().int().min(0),
        })),
    })),
});
export const updateStageTemplateSchema = z.object({
    slug: z.string().min(1).max(100).regex(/^[A-Z_]+$/).optional(),
    label: z.string().min(1).max(255).optional(),
    description: z.string().max(1000).nullable().optional(),
    order: z.number().int().min(0).optional(),
    isActive: z.boolean().optional(),
    stages: z.array(z.object({
        id: z.string().optional(),
        title: z.string().min(1).max(255),
        order: z.number().int().min(0),
        items: z.array(z.object({
            id: z.string().optional(),
            title: z.string().min(1).max(255),
            order: z.number().int().min(0),
        })),
    })).optional(),
});
//# sourceMappingURL=stage.js.map